<template>
  <div class="is-border-top has-background-light is-padding">
    <div class="columns is-multiline ">
      <div class="column is-10">
        <div class="field">
          <r-label
            :is-required="isRequired"
            label="Nom du package"
            :value="pack.name"></r-label>
          <div class="control">
            <v-input
              :id="'name' + idx"
              :name="'name' + idx"
              :model="pack.name"
              :v-validate="isRequired"
              :errors-bag="errors"
              data-vv-value-path="val"
              @input="pack.name = $event"
              data-vv-as="Nom du package">
            </v-input>
          </div>
        </div>
      </div>
      <div class="column is-2 has-text-right">
        <label class="label is-small is-size-7">&nbsp;</label>
        <a
          @click="removePack(idx)"
          class="button is-square is-grey is-inverted is-border is-radiusless">
          <span class="icon"><i class="fal fa-trash-alt fa-lg has-text-grey"></i></span>
        </a>
      </div>
      <div class="column is-4">
        <r-label
          :is-required="isRequired"
          :label="priceHtName"
          :value="pack.sale_price_ht"></r-label>
        <div class="control">
          <v-input
            :has-addons="true"
            :id="'pack_sale_price_ht' + idx"
            :name="'pack_sale_price_ht' + idx"
            @input="pack.sale_price_ht = $event"
            :model="pack.sale_price_ht"
            input-type="number"
            :v-validate="isRequired"
            :errors-bag="errors"
            data-vv-value-path="val"
            :number="true"
            :three-space="true"
            :data-vv-as="'Prix ' + pack.name + ' HT'">
            <div
              class="control"
              slot="addonsRight">
              <a class="button is-static is-border">
                <span class="icon"><i class="fas fa-euro-sign"></i></span><span>HT</span>
              </a>
            </div>
          </v-input>
        </div>
      </div>
      <div class="column is-2">
        <div v-if="pack.sale_price_ht && pack.sale_price_ttc">
          <r-label
            label="TVA"
            :is-required="false"></r-label>
          <div class="has-text-weight-bold has-text-black is-size-4">
            {{ pack.sale_price_ht | tva(pack.sale_price_ttc) | prettyPrice }} %
          </div>
          <div class="has-text-weight-light has-text-black is-size-6">
            {{ pack.sale_price_ttc - pack.sale_price_ht | prettyPrice }} €
          </div>
        </div>
      </div>
      <div class="column is-4">
        <r-label
          :is-required="isRequired"
          :label="priceTTCName"
          :value="pack.sale_price_ttc"></r-label>
        <div class="control">
          <v-input
            :has-addons="true"
            :id="'pack_sale_price_ttc' + idx"
            :name="'pack_sale_price_ttc' + idx"
            @input="pack.sale_price_ttc = $event"
            :model="pack.sale_price_ttc"
            input-type="number"
            :three-space="true"
            :v-validate="isRequired"
            :errors-bag="errors"
            data-vv-value-path="val"
            :number="true"
            :data-vv-as="'Prix ' + pack.name + ' TTC'">
            <p
              class="control"
              slot="addonsRight">
              <a class="button is-static is-border">
                <span class="icon"><i class="fas fa-euro-sign"></i></span><span>TTC</span>
              </a>
            </p>
          </v-input>
        </div>
      </div>
      <div class="column is-4">
        <div class="control">
          <date-picker
            :model="pack.start_date"
            :style-version="2"
            @input="pack.start_date = $event"
            label="Date de début"></date-picker>
        </div>
      </div>
      <div class="column is-2"></div>
      <div class="column is-4">
        <div class="control">
          <date-picker
            :model="pack.end_date"
            :style-version="2"
            @input="pack.end_date = $event"
            label="Date de fin"></date-picker>
        </div>
      </div>
      <div class="column is-2"></div>
      <div class="column is-10">
        <r-label
          label="Détail de l'offre"
          :is-required="false"></r-label>
        <div class="control has-background-white">
          <wysiwyg-editor
            :model="pack.description"
            placeholder=""
            :light="true"
            @change="pack.description = $event"
            class="editr--bottom-toolbar editr--height-small content has-background-white" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LotPrixPackage',
  props: {
    pack: {
      type: Object,
      required: true
    },
    idx: {
      type: Number,
      required: false
    }
  },
  computed: {
    isRequired () {
      if ((this.pack.name !== '' && this.pack.name !== null) || (this.pack.sale_price_ht !== '' && this.pack.sale_price_ht !== null) || (this.pack.sale_price_ttc !== '' && this.pack.sale_price_ttc !== null) || (this.pack.description !== '' && this.pack.description !== null)) {
        return true
      } else {
        return false
      }
    },
    priceHtName () {
      return `Prix ${this.pack.name || ''} HT`
    },
    priceTTCName () {
      return `Prix ${this.pack.name || ''} TTC`
    },
    dateStart () {
      return `Date de début`
    },
    endStart () {
      return `Date de fin`
    }
  },
  methods: {
    removePack (idx) {
      this.$emit('removePack', idx)
    }
  }
}
</script>
